import { useState } from 'react';
import { Plan } from '../../../../types/plan';
import { formatAmountUI } from '../../../../utils/price/price.utils';
import {
  ProgramV2CardsContainer,
  ProgramV2Container,
  ProgramV2Header,
  ProgramV2HeaderText,
  ProgramV2Price,
  ProgramV2PriceDetails,
  ProgramV2PriceImage,
  ProgramV2PriceLabel,
  ProgramV2PriceMonth,
  ProgramV2PriceMonthWrapper,
  ProgramV2PriceTotal,
  ProgramV2PriceTotalSubtitle,
  ProgramV2PriceTotalTitle,
  ProgramV2PriceValue,
  ProgramV2PriceWrapper,
  ProgramV2PriceWrapperImage,
} from './ProgramV2.style';
import { useMst } from '../../../../models/rootModel';
import KlarnaLogo from '../../../../assets/KlarnaLogo.webp';

interface ProgramProps {
  product: Plan;
  chosenPlanPosition: string | null;
  onClick: () => void;
}

export const ProgramV2 = ({ product, onClick, chosenPlanPosition }: ProgramProps) => {
  const { amount, metadata } = product;
  const isPicked = metadata.position === chosenPlanPosition;
  const totalPriceUI = formatAmountUI(amount);
  const { UserPayment } = useMst();
  // this is done for better UX, so user see clicked card immediately when clicked
  const [programWithKlarna, setProgramWithKlarna] = useState(UserPayment.withKlarna);

  const onProgramClick = (withKlarna: boolean) => {
    setProgramWithKlarna(withKlarna);
    UserPayment.setWithKlarna(withKlarna);
    UserPayment.setKlarnaOnly(withKlarna);
    onClick();
  };

  return (
    <ProgramV2CardsContainer>
      <ProgramV2Container enabled={isPicked && programWithKlarna} onClick={() => onProgramClick(true)}>
        <ProgramV2PriceWrapperImage>
          <ProgramV2Header>
            <ProgramV2HeaderText>{metadata.paymentsPlanTitle}</ProgramV2HeaderText>
          </ProgramV2Header>
          <ProgramV2PriceWrapper>
            <ProgramV2Price>
              <ProgramV2PriceLabel>{metadata.paymentsPricingLabel}</ProgramV2PriceLabel>
              <ProgramV2PriceMonthWrapper>
                <ProgramV2PriceValue>${metadata.monthlyPrice}</ProgramV2PriceValue>
                <ProgramV2PriceMonth> /mo</ProgramV2PriceMonth>
              </ProgramV2PriceMonthWrapper>
            </ProgramV2Price>
            <ProgramV2PriceTotal>
              <ProgramV2PriceTotalTitle>{metadata.paymentsSubtitle}</ProgramV2PriceTotalTitle>
              <ProgramV2PriceTotalSubtitle>{metadata.paymentDescription}</ProgramV2PriceTotalSubtitle>
            </ProgramV2PriceTotal>
            <ProgramV2PriceDetails paddingTop={16}>
              Payment terms and fees vary based on <ProgramV2PriceImage src={KlarnaLogo} alt="KlaranaLogo" />
            </ProgramV2PriceDetails>
            <ProgramV2PriceDetails paddingTop={2}>checkout options.</ProgramV2PriceDetails>
          </ProgramV2PriceWrapper>
        </ProgramV2PriceWrapperImage>
      </ProgramV2Container>

      <ProgramV2Container enabled={isPicked && !programWithKlarna} onClick={() => onProgramClick(false)}>
        <ProgramV2PriceWrapperImage>
          <ProgramV2Header>
            <ProgramV2HeaderText>{metadata.planHeader}</ProgramV2HeaderText>
          </ProgramV2Header>
          <ProgramV2PriceWrapper>
            <ProgramV2Price>
              <ProgramV2PriceLabel>{metadata.pricingLabel}</ProgramV2PriceLabel>
              <ProgramV2PriceMonthWrapper>
                <ProgramV2PriceValue>${totalPriceUI}</ProgramV2PriceValue>
              </ProgramV2PriceMonthWrapper>
            </ProgramV2Price>
            <ProgramV2PriceTotal>
              <ProgramV2PriceTotalTitle>{metadata.subtitle}</ProgramV2PriceTotalTitle>
              <ProgramV2PriceTotalSubtitle>{metadata.paymentDescription}</ProgramV2PriceTotalSubtitle>
            </ProgramV2PriceTotal>
            <ProgramV2PriceDetails paddingTop={54}></ProgramV2PriceDetails>
          </ProgramV2PriceWrapper>
        </ProgramV2PriceWrapperImage>
      </ProgramV2Container>
    </ProgramV2CardsContainer>
  );
};
